import React from 'react';
import type { IDBIMenuVO } from '@intelligence/types/menu';

export const MenuListContext = React.createContext<IDBIMenuVO[]>([]);

export type TMenuClickHandler = (menu?: IDBIMenuVO) => boolean | void;

export const MenuClickContext = React.createContext<TMenuClickHandler | undefined>(undefined);
